"use client";

import { useCallback } from "react";

import { useLastTradesByInstrument as useLastTradesByInstrumentQuery } from "#/services/kyan/hooks/useLastTradesByInstrument";
import { useLastTradesByInstrument } from "#/store/app/lastTrades/lastTrades";
import { useOption } from "#/store/options/tradePanel/option";
import { UnderlyingSymbol } from "#/types/markets";

import { useRealtimeLastTradesFeatureFlag } from "./featureFlags/useRealtimeLastTradesFeatureFlag";

export const useLastOptionTradesByInstrument = () => {
  const { option } = useOption();
  const { isRealtimeLastTradesEnabled } = useRealtimeLastTradesFeatureFlag();
  const {
    data,
    isLoading: isLoadingQuery,
    refetch,
  } = useLastTradesByInstrumentQuery({
    instrument_name: option?.instrument_name,
    count: 100,
  });
  const { trades, isLoading: isLoadingWs } = useLastTradesByInstrument(
    option?.instrument_name ?? "",
  );

  const safeRefetch = useCallback(async () => {
    if (isRealtimeLastTradesEnabled) return Promise.resolve();

    if (option?.instrument_name) {
      return await refetch();
    }
    return Promise.resolve();
  }, [option?.instrument_name, refetch, isRealtimeLastTradesEnabled]);

  return {
    lastTrades: isRealtimeLastTradesEnabled ? trades : data,
    underlying: option?.underlying as UnderlyingSymbol | "",
    isLoading: isRealtimeLastTradesEnabled ? isLoadingWs : isLoadingQuery,
    refetch: safeRefetch,
  };
};
